<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
<div class="grey-page">
	<section class="container">
		<h2 class="page__main-title">Administration</h2>
		<div class="admin_box_stat">
			<div class="admin_box_stat_title">Companies</div>
			<div class="admin_box_stat_number">{{numCompanies}}</div>
		</div>
		<div class="admin_box_stat">
			<div class="admin_box_stat_title">Live Mode</div>
			<div class="admin_box_stat_number">{{numCompaniesLive}}</div>
		</div>
		<div class="admin_box_stat">
			<div class="admin_box_stat_title">RM/Zoopla/WP</div>
			<div class="admin_box_stat_number">{{numCompaniesLivePortals}}</div>
		</div>
		<h3>Companies</h3>
		<vue-good-table
			:columns="columns"
			:rows="companiesRows"
			:sort-options="{enabled: true, initialSortBy: {field: 'date', type: 'desc'}}"
			:paginateOptions="{enabled: false}"
			:rowStyleClass="activeRowClass"
			styleClass="vgt-table bordered striped">
			<template slot="table-row" slot-scope="props">
  				<span v-if="props.column.field == 'before'">
					<a href="#" @click.prevent="changeCompany(props.row)" title="Change to this company">
						<i class="ico ico-applicants"></i>
					</a>
				</span>
  				<span v-else-if="props.column.field == 'after'">
					<a href="#" @click.prevent="hideCompany(props.row)" title="Hide company - Dev account">
						<i class="ico ico-archive"></i>
					</a>
					<a href="#" @click.prevent="removeCompany(props.row)" title="Remove company - Dev account">
						<i class="ico ico-delete"></i>
					</a>
				</span>
				<span v-else-if="props.column.html" v-html="props.formattedRow[props.column.field]">
				</span>
				<span v-else>
					{{props.formattedRow[props.column.field]}}
				</span>
			</template>
		</vue-good-table>
	</section>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';

export default {
    data: function() {
        return {
			  columns: [
				  {
					  label: '*',
					  field: 'before'
				  },
				  {
					  label: 'Date',
					  field: 'date',
					  type: 'date',
					  dateInputFormat: 'T',
					  dateOutputFormat: 'yyyy-MM-dd HH:mm',
					  tdClass: 'admin_col_date',
					  width: '85px'
				  },
				  {
					  label: 'Company',
					  field: 'company',
					  filterOptions: {
						  enabled: true
					  }
				  },
				  {
					  label: 'CU',
					  field: 'cu',
					  html: true,
					  filterOptions: {
						  enabled: true,
						  filterDropdownItems: ['YES', 'NO']
					  }
				  },
				  {
					  label: 'Active',
					  field: 'active',
					  html: true,
					  filterOptions: {
						  enabled: true,
						  filterDropdownItems: ['YES', 'NO']
					  }
				  },
				  {
					  label: 'Live',
					  field: 'live',
					  html: true,
					  filterOptions: {
						  enabled: true,
						  filterDropdownItems: ['YES', 'NO']
					  }
				  },
				  {
					  label: 'Props',
					  field: 'properties',
					  type: 'number'
				  },
				  {
					  label: 'Portals',
					  field: 'portals',
					  html: true,
					  filterOptions: {
						  enabled: true,
						  filterDropdownItems: ['Rightmove', 'Zoopla', 'WordPress', 'Any']
					  }
				  },
				  {
					  label: 'User',
					  field: 'user',
					  filterOptions: {
						  enabled: true,
					  }
				  },
				  {
					  label: 'Last Login',
					  field: 'lastLogin',
					  type: 'date',
					  dateInputFormat: 'T',
					  dateOutputFormat: 'yyyy-MM-dd HH:mm',
					  tdClass: 'admin_col_date',
					  width: '85px'
				  },
				  {
					  label: '*',
					  field: 'after'
				  }
			  ],
			  companies: []
        }
    },
    created: async function() {
		 this.companies = await api({endpoint: this.config.services.companies, path: '/admin/companies', method: 'GET'});
    },
    computed: {
		adminCompanyId() {
			return this.$store.getters.adminCompanyId;
		},
		companiesRows() {
			const that = this;
			return this.companies.map(company => {
   			 let portals = '';

   			 if(company.stats && (company.stats.rm || company.stats.zoopla || company.stats.wp)) {
   				if(company.stats.rm && company.stats.rm != 'off') {
   					if(company.stats.rm == 'live') {
   						portals += `<span class="admin_portal admin_rm_live" title="Rightmove" data-portal-filter="Any"></span>`;
   					} else {
   						portals += `<span class="admin_portal admin_rm_active" title="Rightmove waiting activation..." data-portal-filter="Any"></span>`;
   					}
   				}
   				if(company.stats.zoopla && company.stats.zoopla != 'off') {
   					if(company.stats.zoopla == 'live') {
   						portals += `<span class="admin_portal admin_zoopla_live" title="Zoopla" data-portal-filter="Any"></span>`;
   					} else {
   						portals += `<span class="admin_portal admin_zoopla_active" title="Zoopla waiting activation..." data-portal-filter="Any"></span>`;
   					}
				}
				if(company.stats.wp) {
					portals += `<a href="${company.stats.wp}" target="_blank" class="admin_portal admin_wordpress" title="WordPress" data-portal-filter="Any"></a>`;
   				}
   			 }

   			 return {
   				 companyId: company.companyId,
   				 date: company.created_at,
					 cu: company.conditions ? '<span class="admin_yes" data-filter="YES">X</span>' : '<span data-filter="NO"></span>',
   				 active: company.active ? '<span class="admin_yes">YES</span>' : '<span class="admin_no">NO</span>',
   				 live: !company.demoMode ? '<span class="admin_yes">YES</span>' : '<span class="admin_no">NO</span>',
   				 company: company.companyName ? company.companyName : '',
   				 properties: company.stats ? company.stats.properties : 0,
   				 portals: portals,
   				 user: company.email ? company.email: '',
   				 lastLogin: company.lastLogin ? company.lastLogin : ''
   			 }
   		 });
	 },
	 numCompanies() {
		 return this.companies.length;
	 },
	 numCompaniesLive() {
		 return this.companies.reduce(function(total, company) {
			 if(!company.demoMode) {
				 return total + 1;
			 } else {
				 return total;
			 }
		 }, 0);
	 },
	 numCompaniesLivePortals() {
		 return this.companies.reduce(function(total, company) {
			 const hasRMLive = company.stats && company.stats.rm && company.stats.rm == 'live';
			 const hasZooplaLive = company.stats && company.stats.zoopla && company.stats.zoopla == 'live';
			 const hasWordPress = company.stats && company.stats.wp;

			 if(hasRMLive || hasZooplaLive || hasWordPress) {
				 return total + 1;
			 } else {
				 return total;
			 }
		 }, 0);
	 }
    },
	methods: {
		activeRowClass(row) {
			if(row.companyId == this.adminCompanyId) {
				return 'admin_row_current';
			} else {
				return '';
			}
		},
		async changeCompany(row) {
			const newCompanyId = row.companyId;
			const newCompanyName = row.company;
			try {
				const response = await api({endpoint: this.config.services.companies, path: '/admin/changeCompany', method: 'PATCH', body: {companyId: newCompanyId}});
				this.$store.commit('setFullname', response.name);
				this.$store.commit('setPhoto', response.photo);
				this.$store.commit('setCompanyId', response.companyId);
				this.$store.commit('setAdminCompanyId', newCompanyId);
				this.$store.commit('setCompanyName', response.companyName);
				this.$store.commit('setCompanyActive', response.companyActive);
				this.$store.commit('setDemoMode', response.demoMode);
				//this.$store.commit('setLoginInfo', response.info);
				this.$store.commit('setEmail', response.email);
				this.$store.commit('setProPortalsPerProperty', response.pro && response.pro.portalsPerProperty ? response.pro.portalsPerProperty : false);
				this.$store.commit('setSubscriptions', response.subscriptions);
			} catch(err) {
				console.error('Error changing company:', err);
			}
		},
		async hideCompany(row) {
			if(confirm('Are you sure you want to hide this company from admin view?')) {
				const companyId = row.companyId;

				try {
					const response = await api({endpoint: this.config.services.companies, path: '/admin/hide', method: 'PATCH', body: {companyId: companyId, hide: true}});

					this.companies = this.companies.filter(function(company) {
						return company.companyId != companyId;
					});
				} catch(err) {
					console.error('Error changing company:', err);
				}
			}
		},
		async removeCompany(row) {
			if(confirm('Are you sure you want to permanently remove this company from BestAgent?')) {
				const companyId = row.companyId;

				try {
					const response = await api({endpoint: this.config.services.companies, path: '/admin/del', method: 'PATCH', body: { companyId: companyId }});

					this.companies = this.companies.filter(function(company) {
						return company.companyId != companyId;
					});
				} catch(err) {
					console.error('Error changing company:', err);
				}
			}
		}
	}
}
</script>

<style lang="scss">
	.admin_table th {
		font-size: 13px;
	}
	.admin_yes, .admin_no {
		display: inline-block;
		padding: 4px 0;
		width: 32px;
		font-size: 12px;
		text-align: center;
		font-weight: bold;
	}
	.admin_yes {
		background-color: lightgreen;
	}
	.admin_no {
		background-color: red;
		color: white;
	}
	.admin_col_date {
		font-size: 13px;
	}
	.admin_portal {
		position: relative;
		display: inline-block;
		width: 20px;
		height: 20px;
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
	}
	.admin_portal.admin_rm_active, .admin_portal.admin_rm_live { background-image: url(/static/img/rightmove-icon.png); }
	.admin_portal.admin_zoopla_active, .admin_portal.admin_zoopla_live { background-image: url(/static/img/zoopla-icon.png); }
	.admin_portal.admin_wordpress { background-image: url(/static/img/wordpress-icon.png); }
	.admin_portal.admin_rm_active:after, .admin_portal.admin_zoopla_active:after {
		content: "";
		display: block;
		position: absolute;
		top: -3px;
		right: -3px;
		width: 10px;
		height: 10px;
		background-color: red;
		color: white;
		border-radius: 50%;
		z-index: 9999;
	}
	.admin_box_stat {
		display: inline-block;
		width: 150px;
		border: 2px solid black;
		padding: 5px;
		border-radius: 10px;

		&_title {
			text-align: center;
		}

		&_number {
			text-align: center;
			font-size: 40px;
		}
	}
	.admin_box_stat+.admin_box_stat {
		margin-left: 10px;
	}
	.admin_row_current {
		background-color: yellow !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue